import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Fancybox from "./Fancybox";
import TelegramFloatButton from "./TelegramFloatButton";
import { ReactComponent as MaxLogo } from "./assets/Max_logo.svg";
import wbCashCard from "./assets/wbPay1.png";

export default function Home() {
  const { t } = useTranslation();

  const [showCookieBanner, setShowCookieBanner] = useState(false);
  const [tgButtonLift, setTgButtonLift] = useState(0);
  const cookieBannerRef = useRef(null);
  const tgButtonRef = useRef(null);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowCookieBanner(true);
    }
  }, []);

  useEffect(() => {
    if (!showCookieBanner) {
      setTgButtonLift(0);
      return;
    }

    const recalc = () => {
      const bannerEl = cookieBannerRef.current;
      const btnEl = tgButtonRef.current;
      if (!bannerEl || !btnEl) return;

      const bannerRect = bannerEl.getBoundingClientRect();
      const btnRect = btnEl.getBoundingClientRect();

      const overlapsHorizontally = bannerRect.right > btnRect.left;
      const overlapsVertically = bannerRect.bottom > btnRect.top;

      setTgButtonLift(
        overlapsHorizontally && overlapsVertically ? bannerRect.height + 32 : 0
      );
    };

    recalc();

    const resizeObserver = new ResizeObserver(recalc);
    resizeObserver.observe(cookieBannerRef.current);
    window.addEventListener("resize", recalc);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", recalc);
    };
  }, [showCookieBanner]);

  const handleAcceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShowCookieBanner(false);
  };

  useEffect(() => {
    let frontEnd = document.createElement("script");
    frontEnd.src = "/assets/js/_1_accordion.js";
    frontEnd.id = "_1_accordion-js";
    document.body.appendChild(frontEnd);

    return () => {
      document.getElementById("_1_accordion-js").remove();
    };
  }, []);

  useEffect(() => {
    let frontEnd = document.createElement("script");
    frontEnd.src = "/assets/js/_2_anim-cards.js";
    frontEnd.id = "_2_anim-cards-js";
    document.body.appendChild(frontEnd);

    return () => {
      document.getElementById("_2_anim-cards-js").remove();
    };
  }, []);

  useEffect(() => {
    let frontEnd = document.createElement("script");
    frontEnd.src = "/assets/js/_1_scrolling-animations.js"; // 👈 make sure to use the correct path
    frontEnd.id = "_1_scrolling-animations-js";
    document.body.appendChild(frontEnd);

    return () => {
      document.getElementById("_1_scrolling-animations-js").remove();
    };
  }, []);

  return (
    <>
      <section
        className="hero min-height-100vh flex items-end color-white"
        style={{ backgroundImage: 'url("assets/img/hero-img-2.png")' }}
      >
        <div className="container max-width-adaptive-lg padding-y-xl">
          <div className="text-left">
            <div className="text-component margin-bottom-sm">
              <h1 id="intro" className="color-primary text-xxxxl">
                {t("home::Rental service")} <br />
                {t("home::of powerbanks")}
              </h1>
              <p className="text-md">{t("home::Charge on the go!")}</p>
            </div>
          </div>
        </div>
      </section>

      <section
        id="howto"
        className="position-relative z-index-1 flex flex-center padding-y-xl"
      >
        <div className="container max-width-adaptive-lg position-relative z-index-2">
          <div className="grid gap-lg items-center">
            <div className="col-7@md flex flex-center">
              <div className="device-group-1 padding-x-xxl">
                <div className="dev-phone-3d-wrapper">
                  <div
                    className="dev-phone dev-phone--top-light scroll-fx js-scroll-fx"
                    aria-label="Image description"
                    data-scroll-fx-1="rotateY, 40deg, 10deg, 0%, 100%"
                  >
                    <div className="dev-phone__body">
                      <div className="dev-phone__media">
                        <div className="dev-phone__notch" />
                        <img
                          src="assets/img/drop your design here copy.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="dev-phone__shadow" />
                  </div>
                </div>
                <div
                  className="dev-phone dev-phone--top-light"
                  aria-label="Image description"
                >
                  <div className="dev-phone__body">
                    <div className="dev-phone__media">
                      <div className="dev-phone__notch" />
                      <img
                        src="assets/img/Map Default energo mobile.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="dev-phone__shadow" />
                </div>
                <div className="dev-phone-3d-wrapper">
                  <div
                    className="dev-phone dev-phone--top-light scroll-fx js-scroll-fx"
                    aria-label="Image description"
                    data-scroll-fx-1="rotateY, -40deg, -10deg, 0%, 100%"
                  >
                    <div className="dev-phone__body">
                      <div className="dev-phone__media">
                        <div className="dev-phone__notch" />
                        <img
                          src="assets/img/drop your design here-3.png"
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="dev-phone__shadow" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-5@md">
              <div
                className="margin-bottom-lg position-relative@md"
                style={{ left: "-85px" }}
              >
                <h1>{t("home::How it works?")}</h1>
              </div>
              <ol className="text-points text-points--counter grid gap-md margin-bottom-md">
                <li className="text-points__item">
                  <div>
                    <h3 className="text-points__title margin-bottom-sm">
                      {t("home::Install")}{" "}
                      <span className="font-light">
                        {t("home::the mobile app")}
                      </span>
                    </h3>
                    <div className="text-points__subtitle">
                      <div className="app-download-banner__buttons">
                        <a
                          target="blank"
                          href="http://onelink.to/35pdxt"
                          className="download-button download-button--icon js-scroll"
                        >
                          <svg className="icon" width="25" height="30" viewBox="0 0 25 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.5215 15.7414C20.5358 14.6327 20.8302 13.5457 21.3775 12.5814C21.9248 11.6171 22.7071 10.8069 23.6517 10.2263C23.0516 9.3693 22.26 8.66406 21.3398 8.16655C20.4195 7.66904 19.3959 7.39296 18.3503 7.36025C16.1198 7.12612 13.9574 8.69495 12.8208 8.69495C11.6621 8.69495 9.91212 7.38349 8.02764 7.42226C6.80871 7.46164 5.62077 7.8161 4.57956 8.4511C3.53834 9.0861 2.67937 9.97998 2.08634 11.0456C-0.482559 15.4933 1.43361 22.0298 3.8944 25.625C5.12558 27.3854 6.56449 29.3519 8.44726 29.2821C10.2897 29.2057 10.9778 28.1073 13.2017 28.1073C15.405 28.1073 16.0506 29.2821 17.9716 29.2378C19.9486 29.2057 21.1942 27.4695 22.3822 25.6924C23.2668 24.4381 23.9475 23.0517 24.399 21.5847C23.2505 21.0989 22.2703 20.2858 21.5808 19.2467C20.8912 18.2075 20.5228 16.9885 20.5215 15.7414Z" fill="white" />
                            <path d="M16.893 4.99591C17.971 3.70188 18.502 2.03863 18.3734 0.359375C16.7266 0.532345 15.2054 1.31943 14.1129 2.56381C13.5787 3.17172 13.1696 3.87894 12.9089 4.64505C12.6483 5.41117 12.5411 6.22115 12.5937 7.02868C13.4174 7.03716 14.2323 6.85863 14.977 6.50652C15.7218 6.1544 16.3769 5.6379 16.893 4.99591Z" fill="white" />
                          </svg>
                        </a>
                        <a
                          target="blank"
                          href="https://play.google.com/store/apps/details?id=com.energo.rnapp&hl=ru"
                          className="download-button download-button--icon js-scroll"
                        >
                          <svg className="icon" width="27" height="30" viewBox="0 0 27 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.71873 0.730379C3.97369 0.281888 3.08575 0.241784 2.31134 0.61515L15.2955 13.627L19.5409 9.36184L4.71873 0.730379ZM1.11838 1.81941C0.954572 2.16623 0.866455 2.55202 0.866455 2.94911V26.7507C0.866455 27.1495 0.955136 27.5297 1.12064 27.8691L14.0997 14.8285L1.11838 1.81941ZM15.2973 16.0282L2.33399 29.0531C2.67798 29.2123 3.04401 29.2818 3.40946 29.2818C3.86078 29.2818 4.31096 29.1739 4.71878 28.9288L19.5438 20.2843L15.2973 16.0282ZM25.1861 12.6493C25.181 12.6459 25.1754 12.6425 25.1703 12.6397L21.0548 10.243L16.4925 14.8268L21.0576 19.4015C21.0576 19.4015 25.181 16.9975 25.1861 16.9946C25.9515 16.5298 26.4084 15.7175 26.4084 14.8217C26.4084 13.9258 25.9515 13.1136 25.1861 12.6493Z" fill="white" />
                          </svg>
                        </a>
                        <a
                          target="blank"
                          href="https://www.rustore.ru/catalog/app/com.energo.rnapp"
                          className="download-button download-button--icon js-scroll"
                        >
                          <img className="icon" src="assets/img/Rustore.svg" alt="RuStore" width="34" height="32" />
                        </a>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="text-points__item">
                  <div className="text-component">
                    <h3 className="text-points__title">
                      {t("home::Take")}{" "}
                      <span className="font-light">
                        {t("home::a powerbank")} <br />
                        {t("home::at the nearest terminal")}
                      </span>
                    </h3>
                    <p className="text-points__subtitle">
                      {t(
                        "home::Find the terminal in the application that is next to you. Scan the QR code or enter the number terminal."
                      )}
                    </p>
                  </div>
                </li>
                <li className="text-points__item">
                  <div className="text-component">
                    <h3 className="text-points__title">
                      {t("home::Charge")}{" "}
                      <span className="font-light">
                        {t("home::on the go")} <br />
                        {t("home::and hand over in a convenient place")}
                      </span>
                    </h3>
                    <p className="text-points__subtitle">
                      {t(
                        "home::Take the powerbank with you and return it anywhere from the app."
                      )}
                    </p>
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      {/* App Download Banner */}
      <section id="tariff-info" className="padding-y-lg">
        <div className="container max-width-lg">
          <div
            className="app-download-banner scroll-fx js-scroll-fx"
            data-scroll-fx="translateY, 20px, 0px, 0%, 100%"
            style={{
              background: 'linear-gradient(135deg, #f3f3f3 0%, #e9e9e9 100%)',
              borderRadius: '16px',
              overflow: 'hidden',
              position: 'relative'
            }}
          >
            <div className="app-download-banner__container">
              <div className="app-download-banner__left">
                <div className="app-download-banner__content">
                  <h3>
                    {t("home::Install app and charge")} <br />
                    {t("home::and charge yourself")}
                  </h3>
                </div>

                <div className="app-download-banner__buttons">
                  <a
                    href="http://onelink.to/35pdxt"
                    className="download-button download-button--icon js-scroll"
                  >
                    <svg className="icon" width="25" height="30" viewBox="0 0 25 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20.5215 15.7414C20.5358 14.6327 20.8302 13.5457 21.3775 12.5814C21.9248 11.6171 22.7071 10.8069 23.6517 10.2263C23.0516 9.3693 22.26 8.66406 21.3398 8.16655C20.4195 7.66904 19.3959 7.39296 18.3503 7.36025C16.1198 7.12612 13.9574 8.69495 12.8208 8.69495C11.6621 8.69495 9.91212 7.38349 8.02764 7.42226C6.80871 7.46164 5.62077 7.8161 4.57956 8.4511C3.53834 9.0861 2.67937 9.97998 2.08634 11.0456C-0.482559 15.4933 1.43361 22.0298 3.8944 25.625C5.12558 27.3854 6.56449 29.3519 8.44726 29.2821C10.2897 29.2057 10.9778 28.1073 13.2017 28.1073C15.405 28.1073 16.0506 29.2821 17.9716 29.2378C19.9486 29.2057 21.1942 27.4695 22.3822 25.6924C23.2668 24.4381 23.9475 23.0517 24.399 21.5847C23.2505 21.0989 22.2703 20.2858 21.5808 19.2467C20.8912 18.2075 20.5228 16.9885 20.5215 15.7414Z" fill="white" />
                      <path d="M16.893 4.99591C17.971 3.70188 18.502 2.03863 18.3734 0.359375C16.7266 0.532345 15.2054 1.31943 14.1129 2.56381C13.5787 3.17172 13.1696 3.87894 12.9089 4.64505C12.6483 5.41117 12.5411 6.22115 12.5937 7.02868C13.4174 7.03716 14.2323 6.85863 14.977 6.50652C15.7218 6.1544 16.3769 5.6379 16.893 4.99591Z" fill="white" />
                    </svg>
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.energo.rnapp&hl=ru"
                    className="download-button download-button--icon js-scroll"
                  >
                    <svg className="icon" width="27" height="30" viewBox="0 0 27 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.71873 0.730379C3.97369 0.281888 3.08575 0.241784 2.31134 0.61515L15.2955 13.627L19.5409 9.36184L4.71873 0.730379ZM1.11838 1.81941C0.954572 2.16623 0.866455 2.55202 0.866455 2.94911V26.7507C0.866455 27.1495 0.955136 27.5297 1.12064 27.8691L14.0997 14.8285L1.11838 1.81941ZM15.2973 16.0282L2.33399 29.0531C2.67798 29.2123 3.04401 29.2818 3.40946 29.2818C3.86078 29.2818 4.31096 29.1739 4.71878 28.9288L19.5438 20.2843L15.2973 16.0282ZM25.1861 12.6493C25.181 12.6459 25.1754 12.6425 25.1703 12.6397L21.0548 10.243L16.4925 14.8268L21.0576 19.4015C21.0576 19.4015 25.181 16.9975 25.1861 16.9946C25.9515 16.5298 26.4084 15.7175 26.4084 14.8217C26.4084 13.9258 25.9515 13.1136 25.1861 12.6493Z" fill="white" />
                    </svg>
                  </a>
                  <a
                    href="https://www.rustore.ru/catalog/app/com.energo.rnapp"
                    className="download-button download-button--icon js-scroll"
                  >
                    <img className="icon" src="assets/img/Rustore.svg" alt="RuStore" width="34" height="32" />
                  </a>
                </div>
              </div>

              <div className="app-download-banner__price">
                <div className="price-main">{t("home::200 rubles per 24 hours")}</div>
                <div className="price-subtitle">
                  {t("home::Current rates shown")} <br />
                  {t("home::on terminals and in app")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="partners" className="position-relative z-index-1">
        <div className="container max-width-lg position-relative z-index-2">
          <div className="margin-bottom-lg text-center">
            <h1 className="margin-bottom-sm color-inherit">
              {t("home::Where are we located?")}
            </h1>
            <p>{t("home::More than 1000 terminals throughout Moscow")}</p>
          </div>
          <div className="grid gap-lg margin-bottom-md">
            <div className="col-6 col-4@md">
              <div className="flex flex-column flex-center gap-sm">
                <figure className="flex-shrink-0">
                  <img
                    className="block width-xl width-xxxl@md"
                    src="assets/img/feature-v7-img-1.svg"
                    alt=""
                  />
                </figure>
                <div className="text-component text-center">
                  <h4 className="color-inherit font-light text-md">
                    {t("home::Transport hubs")}
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-6 col-4@md">
              <div className="flex flex-column flex-center gap-sm">
                <figure className="flex-shrink-0">
                  <img
                    className="block width-xl width-xxxl@md"
                    src="assets/img/feature-v7-img-2.svg"
                    alt=""
                  />
                </figure>
                <div className="text-component text-center">
                  <h4 className="color-inherit font-light text-md">
                    {t("home::Fitness clubs")}
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-6 col-4@md">
              <div className="flex flex-column flex-center gap-sm">
                <figure className="flex-shrink-0">
                  <img
                    className="block width-xl width-xxxl@md"
                    src="assets/img/feature-v7-img-3.svg"
                    alt=""
                  />
                </figure>
                <div className="text-component text-center">
                  <h4 className="color-inherit font-light text-md">
                    {t("home::Central markets")}
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-6 col-4@md">
              <div className="flex flex-column flex-center gap-sm">
                <figure className="flex-shrink-0">
                  <img
                    className="block width-xl width-xxxl@md"
                    src="assets/img/feature-v7-img-4.svg"
                    alt=""
                  />
                </figure>
                <div className="text-component text-center">
                  <h4 className="color-inherit font-light text-md">
                    {t("home::Cafes and restaurants")}
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-6 col-4@md">
              <div className="flex flex-column flex-center gap-sm">
                <figure className="flex-shrink-0">
                  <img
                    className="block width-xl width-xxxl@md"
                    src="assets/img/feature-v7-img-5.svg"
                    alt=""
                  />
                </figure>
                <div className="text-component text-center">
                  <h4 className="color-inherit font-light text-md">
                    {t("home::Shopping malls")}
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-6 col-4@md">
              <div className="flex flex-column flex-center gap-sm">
                <figure className="flex-shrink-0">
                  <img
                    className="block width-xl width-xxxl@md"
                    src="assets/img/feature-v7-img-6.svg"
                    alt=""
                  />
                </figure>
                <div className="text-component text-center">
                  <h4 className="color-inherit font-light text-md">
                    {t("home::All over the city")}
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-center padding-y-md">
            <a
              target="blank"
              href="http://onelink.to/35pdxt"
              className="btn btn--primary btn--md"
            >
              {t("home::Find the nearest")}
            </a>
          </div>
          <div className="flex justify-between">
            <button
              className="reset anim-cards-control js-anim-cards-control js-tab-focus margin-left-auto"
              aria-controls="animated-cards"
              aria-label="pause animation"
              aria-pressed="false"
            >
              <i />
            </button>
          </div>
        </div>

        <Fancybox options={{ infinite: false }}>
          <div id="animated-cards" className="position-relative z-index-2">
            <div className="anim-cards js-anim-cards">
              <ul className="anim-cards__list">
                <li className="anim-cards__item">
                  <div className="card-v2 radius-md">
                    <a
                      data-fancybox="demo"
                      href="assets/img/anim-cards-img-1.png"
                    >
                      <img src="assets/img/anim-cards-img-1.png" alt="" />
                    </a>
                  </div>
                </li>
                <li className="anim-cards__item">
                  <div className="card-v2 radius-md">
                    <a
                      data-fancybox="demo"
                      href="assets/img/anim-cards-img-2.png"
                    >
                      <img src="assets/img/anim-cards-img-2.png" alt="" />
                    </a>
                  </div>
                </li>
                <li className="anim-cards__item">
                  <div className="card-v2 radius-md">
                    <a
                      data-fancybox="demo"
                      href="assets/img/anim-cards-img-3.png"
                    >
                      <img src="assets/img/anim-cards-img-3.png" alt="" />
                    </a>
                  </div>
                </li>
                <li className="anim-cards__item">
                  <div className="card-v2 radius-md">
                    <a
                      data-fancybox="demo"
                      href="assets/img/anim-cards-img-1.png"
                    >
                      <img src="assets/img/anim-cards-img-1.png" alt="" />
                    </a>
                  </div>
                </li>
                <li className="anim-cards__item">
                  <div className="card-v2 radius-md">
                    <a
                      data-fancybox="demo"
                      href="assets/img/anim-cards-img-2.png"
                    >
                      <img src="assets/img/anim-cards-img-2.png" alt="" />
                    </a>
                  </div>
                </li>
                <li className="anim-cards__item">
                  <div className="card-v2 radius-md">
                    <a
                      data-fancybox="demo"
                      href="assets/img/anim-cards-img-3.png"
                    >
                      <img src="assets/img/anim-cards-img-3.png" alt="" />
                    </a>
                  </div>
                </li>
              </ul>
            </div>
            <div className="anim-cards anim-cards--reverse js-anim-cards">
              <ul className="anim-cards__list">
                <li className="anim-cards__item">
                  <div className="card-v2 radius-md">
                    <a
                      data-fancybox="demo"
                      href="assets/img/anim-cards-img-1.png"
                    >
                      <img src="assets/img/anim-cards-img-1.png" alt="" />
                    </a>
                  </div>
                </li>
                <li className="anim-cards__item">
                  <div className="card-v2 radius-md">
                    <a
                      data-fancybox="demo"
                      href="assets/img/anim-cards-img-2.png"
                    >
                      <img src="assets/img/anim-cards-img-2.png" alt="" />
                    </a>
                  </div>
                </li>
                <li className="anim-cards__item">
                  <div className="card-v2 radius-md">
                    <a
                      data-fancybox="demo"
                      href="assets/img/anim-cards-img-3.png"
                    >
                      <img src="assets/img/anim-cards-img-3.png" alt="" />
                    </a>
                  </div>
                </li>
                <li className="anim-cards__item">
                  <div className="card-v2 radius-md">
                    <a
                      data-fancybox="demo"
                      href="assets/img/anim-cards-img-1.png"
                    >
                      <img src="assets/img/anim-cards-img-1.png" alt="" />
                    </a>
                  </div>
                </li>
                <li className="anim-cards__item">
                  <div className="card-v2 radius-md">
                    <a
                      data-fancybox="demo"
                      href="assets/img/anim-cards-img-2.png"
                    >
                      <img src="assets/img/anim-cards-img-2.png" alt="" />
                    </a>
                  </div>
                </li>
                <li className="anim-cards__item">
                  <div className="card-v2 radius-md">
                    <a
                      data-fancybox="demo"
                      href="assets/img/anim-cards-img-3.png"
                    >
                      <img src="assets/img/anim-cards-img-3.png" alt="" />
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </Fancybox>
      </section>

      <section id="faq" className="position-relative z-index-1 padding-y-xl">
        <div className="container max-width-md position-relative z-index-2">
          <div className="margin-bottom-lg">
            <h1 className="text-center">{t("home::Frequent questions")}</h1>
          </div>
          <ul
            className="accordion js-accordion margin-bottom-xl"
            data-animation="on"
            data-multi-items="on"
          >
            <li className="accordion__item js-accordion__item">
              <button
                className="reset accordion__header padding-y-sm padding-x-md js-tab-focus"
                type="button"
              >
                <span className="text-md">
                  {t("home::How to use?")}
                </span>
                <svg
                  className="icon accordion__icon-plus no-js:is-hidden"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <g
                    className="icon__group"
                    fill="none"
                    stroke="currentColor"
                    strokeMiterlimit={10}
                  >
                    <line x1={1} y1={8} x2={15} y2={8} />
                    <line x1={1} y1={8} x2={15} y2={8} />
                  </g>
                </svg>
              </button>
              <div className="accordion__panel padding-top-xxs padding-x-md padding-bottom-md js-accordion__panel">
                <div className="text-component">
                  <ol>
                    <li>
                      {t("home::Download the EnerGO mobile app from App Store, Google Play and Rustore.")}
                    </li>
                    <li>
                      {t("home::Choose a convenient authorization method: Telegram, VK, Google, Apple or by phone number.")}
                    </li>
                    <li>
                      {t("home::Add a convenient payment method. Important: only cashless payment!")}
                    </li>
                    <li>{t("home::Find the nearest terminal on the map.")}</li>
                    <li>
                      {t(
                        "home::In the mobile app, scan the QR code on the terminal or enter its number manually."
                      )}
                    </li>
                    <li>
                      {t("home::Pay for the rental. Important: we only accept cashless payment.")}
                    </li>
                    <li>
                      {t(
                        "home::After 10 seconds, remove the power bank from the cell."
                      )}
                    </li>
                    <li>
                      {t("home::When you're done using it, return the power bank to the nearest station.")}
                    </li>
                  </ol>
                  {t("home::More information")} <a href="rukovodstvo_polzovatelya_energo.pdf" target="blank">{t("home::here")}</a>
                </div>
              </div>
            </li>
            <li className="accordion__item js-accordion__item">
              <button
                className="reset accordion__header padding-y-sm padding-x-md js-tab-focus"
                type="button"
              >
                <span className="text-md">
                  {t("home::How much does the rent cost?")}
                </span>
                <svg
                  className="icon accordion__icon-plus no-js:is-hidden"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <g
                    className="icon__group"
                    fill="none"
                    stroke="currentColor"
                    strokeMiterlimit={10}
                  >
                    <line x1={1} y1={8} x2={15} y2={8} />
                    <line x1={1} y1={8} x2={15} y2={8} />
                  </g>
                </svg>
              </button>
              <div className="accordion__panel padding-top-xxs padding-x-md padding-bottom-md js-accordion__panel">
                <div className="text-component">
                  <p>
                    {t("home::Basic rate:")} <br />
                    {t("home::50₽/first hour, then 100₽/per day")} <br />
                    {t(
                      "home::Please note that the cost may vary in different places and establishments."
                    )}{" "}
                    <br />
                    {t(
                      "home::The current rates are indicated on the terminals and in the application."
                    )}{" "}
                    <br />
                    {t(
                      "home::The money is debited from your card before the start of the rental and according to the time counter."
                    )}
                  </p>
                </div>
              </div>
            </li>
            <li className="accordion__item js-accordion__item">
              <button
                className="reset accordion__header padding-y-sm padding-x-md js-tab-focus"
                type="button"
              >
                <span className="text-md">
                  {t("home::How to return the battery?")}
                </span>
                <svg
                  className="icon accordion__icon-plus no-js:is-hidden"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <g
                    className="icon__group"
                    fill="none"
                    stroke="currentColor"
                    strokeMiterlimit={10}
                  >
                    <line x1={1} y1={8} x2={15} y2={8} />
                    <line x1={1} y1={8} x2={15} y2={8} />
                  </g>
                </svg>
              </button>
              <div className="accordion__panel padding-top-xxs padding-x-md padding-bottom-md js-accordion__panel">
                <div className="text-component">
                  <ol>
                    <li>
                      {t(
                        "home::Find the nearest terminal on the map in the app."
                      )}
                    </li>
                    <li>
                      {t("home::Click the “return battery“ button in the app.")}
                    </li>
                    <li>{t("home::Insert the battery into a free cell.")}</li>
                  </ol>
                </div>
              </div>
            </li>
            <li className="accordion__item js-accordion__item">
              <button
                className="reset accordion__header padding-y-sm padding-x-md js-tab-focus"
                type="button"
              >
                <span className="text-md">
                  {t("home::Which phones can be charged?")}
                </span>
                <svg
                  className="icon accordion__icon-plus no-js:is-hidden"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <g
                    className="icon__group"
                    fill="none"
                    stroke="currentColor"
                    strokeMiterlimit={10}
                  >
                    <line x1={1} y1={8} x2={15} y2={8} />
                    <line x1={1} y1={8} x2={15} y2={8} />
                  </g>
                </svg>
              </button>
              <div className="accordion__panel padding-top-xxs padding-x-md padding-bottom-md js-accordion__panel">
                <div className="text-component">
                  <p>{t("home::Each battery has three cables:")}</p>
                  <ol>
                    <li>Type-C</li>
                    <li>Lightning</li>
                    <li>MicroUSB</li>
                  </ol>
                </div>
              </div>
            </li>
            <li className="accordion__item js-accordion__item">
              <button
                className="reset accordion__header padding-y-sm padding-x-md js-tab-focus"
                type="button"
              >
                <span className="text-md">
                  {t("home::How many batteries")}{" "}
                  <span className="flex inline-flex@md">
                    {t("home::can I take?")}
                  </span>
                </span>
                <svg
                  className="icon accordion__icon-plus no-js:is-hidden"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <g
                    className="icon__group"
                    fill="none"
                    stroke="currentColor"
                    strokeMiterlimit={10}
                  >
                    <line x1={1} y1={8} x2={15} y2={8} />
                    <line x1={1} y1={8} x2={15} y2={8} />
                  </g>
                </svg>
              </button>
              <div className="accordion__panel padding-top-xxs padding-x-md padding-bottom-md js-accordion__panel">
                <div className="text-component">
                  <p>
                    {t(
                      "home::You can take up to four powerbanks on one account."
                    )}
                  </p>
                </div>
              </div>
            </li>
            <li className="accordion__item js-accordion__item">
              <button
                className="reset accordion__header padding-y-sm padding-x-md js-tab-focus"
                type="button"
              >
                <span className="text-md">
                  {t("home::Cooperation with us")}
                </span>
                <svg
                  className="icon accordion__icon-plus no-js:is-hidden"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <g
                    className="icon__group"
                    fill="none"
                    stroke="currentColor"
                    strokeMiterlimit={10}
                  >
                    <line x1={1} y1={8} x2={15} y2={8} />
                    <line x1={1} y1={8} x2={15} y2={8} />
                  </g>
                </svg>
              </button>
              <div className="accordion__panel padding-top-xxs padding-x-md padding-bottom-md js-accordion__panel">
                <div className="text-component">
                  <p>
                    {t("home::Contact the commercial department by number")}{" "}
                    <a
                      className="color-contrast-medium"
                      href="tel:+74951201876"
                    >
                      8 (495) 120-18-76
                    </a>{" "}
                    <br />
                    {t("home::On weekdays from 9:00 to 18:00")}
                  </p>
                </div>
              </div>
            </li>
            <li className="accordion__item js-accordion__item">
              <button
                className="reset accordion__header padding-y-sm padding-x-md js-tab-focus"
                type="button"
              >
                <span className="text-md">
                  {t(
                    "home::Why do we charge for a day if the power bank charges for only 2 hours?"
                  )}
                </span>
                <svg
                  className="icon accordion__icon-plus no-js:is-hidden"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <g
                    className="icon__group"
                    fill="none"
                    stroke="currentColor"
                    strokeMiterlimit={10}
                  >
                    <line x1={1} y1={8} x2={15} y2={8} />
                    <line x1={1} y1={8} x2={15} y2={8} />
                  </g>
                </svg>
              </button>
              <div className="accordion__panel padding-top-xxs padding-x-md padding-bottom-md js-accordion__panel">
                <div className="text-component">
                  <p>
                    {t(
                      "home::The power bank charge is enough to fully charge the phone up to 100% in 2 hours (capacity 5000 mAh). The rates are calculated specifically so that you can safely hand over the powerbank at a convenient time and place for you."
                    )}
                  </p>
                </div>
              </div>
            </li>
          </ul>
          <div className="margin-bottom-lg">
            <h1 className="text-center">{t("home::What to do if")}</h1>
          </div>
          <ul
            className="accordion js-accordion padding-bottom-xl"
            data-animation="on"
            data-multi-items="on"
          >
            <li className="accordion__item js-accordion__item">
              <button
                className="reset accordion__header padding-y-sm padding-x-md js-tab-focus"
                type="button"
              >
                <span className="text-md">
                  {t("home::The terminal is not working")}
                </span>
                <svg
                  className="icon accordion__icon-plus no-js:is-hidden"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <g
                    className="icon__group"
                    fill="none"
                    stroke="currentColor"
                    strokeMiterlimit={10}
                  >
                    <line x1={1} y1={8} x2={15} y2={8} />
                    <line x1={1} y1={8} x2={15} y2={8} />
                  </g>
                </svg>
              </button>
              <div className="accordion__panel padding-top-xxs padding-x-md padding-bottom-md js-accordion__panel">
                <div className="text-component">
                  <p>
                    {t("home::Contact technical support by phone")}{" "}
                    <span className="flex inline-flex@md">
                      <a
                        className="color-contrast-medium"
                        href="tel:+78006004264"
                      >
                        8 (800) 600-42-64
                      </a>
                    </span>
                  </p>
                </div>
              </div>
            </li>
            <li className="accordion__item js-accordion__item">
              <button
                className="reset accordion__header padding-y-sm padding-x-md js-tab-focus"
                type="button"
              >
                <span className="text-md">
                  {t("home::The QR code is not readable")}
                </span>
                <svg
                  className="icon accordion__icon-plus no-js:is-hidden"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <g
                    className="icon__group"
                    fill="none"
                    stroke="currentColor"
                    strokeMiterlimit={10}
                  >
                    <line x1={1} y1={8} x2={15} y2={8} />
                    <line x1={1} y1={8} x2={15} y2={8} />
                  </g>
                </svg>
              </button>
              <div className="accordion__panel padding-top-xxs padding-x-md padding-bottom-md js-accordion__panel">
                <div className="text-component">
                  <p>
                    {t(
                      "home::If you are in the subway, then enter 6 digits under the QR code."
                    )}{" "}
                    <br />
                    {t(
                      "home::If in an institution, then contact technical support by phone"
                    )}{" "}
                    <span className="flex inline-flex@md">
                      <a
                        className="color-contrast-medium"
                        href="tel:+78006004264"
                      >
                        8 (800) 600-42-64
                      </a>
                    </span>
                  </p>
                </div>
              </div>
            </li>
            <li className="accordion__item js-accordion__item">
              <button
                className="reset accordion__header padding-y-sm padding-x-md js-tab-focus"
                type="button"
              >
                <span className="text-md">
                  {t("home::The terminal has run out of batteries")}
                </span>
                <svg
                  className="icon accordion__icon-plus no-js:is-hidden"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <g
                    className="icon__group"
                    fill="none"
                    stroke="currentColor"
                    strokeMiterlimit={10}
                  >
                    <line x1={1} y1={8} x2={15} y2={8} />
                    <line x1={1} y1={8} x2={15} y2={8} />
                  </g>
                </svg>
              </button>
              <div className="accordion__panel padding-top-xxs padding-x-md padding-bottom-md js-accordion__panel">
                <div className="text-component">
                  <p>
                    {t(
                      "home::Find the nearest terminal in the application where there are free batteries."
                    )}
                  </p>
                </div>
              </div>
            </li>
            <li className="accordion__item js-accordion__item">
              <button
                className="reset accordion__header padding-y-sm padding-x-md js-tab-focus"
                type="button"
              >
                <span className="text-md">
                  {t(
                    "home::The lease started, but the terminal did not issue the battery"
                  )}
                </span>
                <svg
                  className="icon accordion__icon-plus no-js:is-hidden"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <g
                    className="icon__group"
                    fill="none"
                    stroke="currentColor"
                    strokeMiterlimit={10}
                  >
                    <line x1={1} y1={8} x2={15} y2={8} />
                    <line x1={1} y1={8} x2={15} y2={8} />
                  </g>
                </svg>
              </button>
              <div className="accordion__panel padding-top-xxs padding-x-md padding-bottom-md js-accordion__panel">
                <div className="text-component">
                  <p>
                    {t(
                      "home::Check the cell again – you may not have seen the issued battery. If nothing has happened, contact technical support by phone"
                    )}{" "}
                    <a
                      className="color-contrast-medium"
                      href="tel:+78006004264"
                    >
                      8 (800) 600-42-64
                    </a>
                  </p>
                </div>
              </div>
            </li>
            <li className="accordion__item js-accordion__item">
              <button
                className="reset accordion__header padding-y-sm padding-x-md js-tab-focus"
                type="button"
              >
                <span className="text-md">
                  {t(
                    "home::The rented battery does not work (the indicator does not light, the cable is torn off)"
                  )}
                </span>
                <svg
                  className="icon accordion__icon-plus no-js:is-hidden"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <g
                    className="icon__group"
                    fill="none"
                    stroke="currentColor"
                    strokeMiterlimit={10}
                  >
                    <line x1={1} y1={8} x2={15} y2={8} />
                    <line x1={1} y1={8} x2={15} y2={8} />
                  </g>
                </svg>
              </button>
              <div className="accordion__panel padding-top-xxs padding-x-md padding-bottom-md js-accordion__panel">
                <div className="text-component">
                  <p>
                    {t("home::Contact technical support by phone")}{" "}
                    <span className="flex inline-flex@md">
                      <a
                        className="color-contrast-medium"
                        href="tel:+78006004264"
                      >
                        8 (800) 600-42-64
                      </a>
                    </span>
                  </p>
                </div>
              </div>
            </li>
            <li className="accordion__item js-accordion__item">
              <button
                className="reset accordion__header padding-y-sm padding-x-md js-tab-focus"
                type="button"
              >
                <span className="text-md">
                  {t("home::Lost powerbank / damaged")}
                </span>
                <svg
                  className="icon accordion__icon-plus no-js:is-hidden"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <g
                    className="icon__group"
                    fill="none"
                    stroke="currentColor"
                    strokeMiterlimit={10}
                  >
                    <line x1={1} y1={8} x2={15} y2={8} />
                    <line x1={1} y1={8} x2={15} y2={8} />
                  </g>
                </svg>
              </button>
              <div className="accordion__panel padding-top-xxs padding-x-md padding-bottom-md js-accordion__panel">
                <div className="text-component">
                  <p>
                    {t("home::Contact technical support by phone")}{" "}
                    <span className="flex inline-flex@md">
                      <a
                        className="color-contrast-medium"
                        href="tel:+78006004264"
                      >
                        8 (800) 600-42-64
                      </a>
                    </span>
                  </p>
                </div>
              </div>
            </li>
            <li className="accordion__item js-accordion__item">
              <button
                className="reset accordion__header padding-y-sm padding-x-md js-tab-focus"
                type="button"
              >
                <span className="text-md">
                  {t(
                    "home::There is no access to the phone number and you need to hand over the battery?"
                  )}
                </span>
                <svg
                  className="icon accordion__icon-plus no-js:is-hidden"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <g
                    className="icon__group"
                    fill="none"
                    stroke="currentColor"
                    strokeMiterlimit={10}
                  >
                    <line x1={1} y1={8} x2={15} y2={8} />
                    <line x1={1} y1={8} x2={15} y2={8} />
                  </g>
                </svg>
              </button>
              <div className="accordion__panel padding-top-xxs padding-x-md padding-bottom-md js-accordion__panel">
                <div className="text-component">
                  <p>
                    {t(
                      "home::If you rent a powerbank to an institution, then just insert it into the terminal."
                    )}{" "}
                    <br />
                    {t(
                      "home::If in the subway, then contact technical support by phone"
                    )}{" "}
                    <span className="flex inline-flex@md">
                      <a
                        className="color-contrast-medium"
                        href="tel:+78006004264"
                      >
                        8 (800) 600-42-64
                      </a>
                    </span>
                  </p>
                </div>
              </div>
            </li>
          </ul>
          <div className="margin-bottom-lg text-center">
            <h1 className="margin-bottom-sm">
              {t("home::Any other questions?")}
            </h1>
            <p>{t("home::Write to us! We at EnerGO are all charged up!")}</p>
          </div>
          <ul className="socials__btns flex flex-center gap-sm flex-wrap">
            <li>
              <a target="blank" href="https://t.me/HelpEnerGO_bot">
                <svg className="fab fa-telegram-plane icon" viewBox="0 0 448 512" width="1em" height="1em" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z" />
                </svg>
              </a>
            </li>
            <li>
              <a target="blank" href="https://max.ru/id5024194594_bot">
                <MaxLogo className="icon max-icon" width="24" height="24" />
              </a>
            </li>
            {/* <li>
              <a
                target="blank"
                href="https://wa.me/79265358000"
                className="padding-left-xxxs"
              >
                <i className="fab fa-whatsapp icon" />

              </a>
            </li> */}
            {/* <svg class="icon" viewbox="0 0 32 32"><title>Follow us on Facebook</title><path d="M32,16A16,16,0,1,0,13.5,31.806V20.625H9.438V16H13.5V12.475c0-4.01,2.389-6.225,6.043-6.225a24.644,24.644,0,0,1,3.582.312V10.5H21.107A2.312,2.312,0,0,0,18.5,13v3h4.438l-.71,4.625H18.5V31.806A16,16,0,0,0,32,16Z"></path></svg> */}
            <li>
              <a target="blank" href="mailto:support@energo.app">
                <svg className="fas fa-envelope icon" viewBox="0 0 512 512" width="1em" height="1em" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z" />
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </section>

      <section id="promotions" className="wb-promo-section position-relative z-index-1">
        <div className="container max-width-lg position-relative z-index-2">
          <div className="wb-promo">
            <div className="wb-promo__media">
              <img
                src={wbCashCard}
                alt=""
              />
              <div className="wb-promo__image-text">
                КЕШБЕК 5% за оплату <br />
                через WB кошелек
              </div>
            </div>
            <div className="wb-promo__content">
              <h2 className="wb-promo__title">
                Заряженое лето <br />
                с EnerGO и WB Банком
              </h2>
              <p className="wb-promo__text">
                16+ Реклама. ООО "ВБ БАНК", лицензия ЦБ РФ №841 от 22.01.2026 г., ИНН 0102000578. Акция действует до 31.12.26 при взятии пауэрбанка в приложении EnerGO с использованием WB Кошелька. Кешбэк - возврат баллами (маркетинговое наименование - «ягодки») части стоимости покупки, начисляемыми в соответствии с условиями акции, и отображаемыми личном кабинете участника акции в приложении Wildberries ООО «РВБ». Правила проведения акции и программа лояльности - на{" "}
                <a
                  href="https://wb-bank.ru/documents/pravila-akcii-bally-za-ispolzovanie-servisa-wb-oplata-v-partnerskih-tsp.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://wb-bank.ru/documents/pravila-akcii-bally-za-ispolzovanie-servisa-wb-oplata-v-partnerskih-tsp.pdf
                </a>
                . Партнер акции: ООО "ЭНЕРГО ТЕХНОЛОДЖИС". Продавец: ООО "ЭНЕРГО ТЕХНОЛОДЖИС". ОГРН 1195081019803, г. Москва
              </p>
              <div className="wb-promo__actions">
                <a
                  className="wb-promo__button"
                  href="wb_energo_promo.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  Посмотреть
                </a>
                <a
                  className="wb-promo__button"
                  href="https://energo.onelink.me/gTTu?deep_link_value=sWallet"
                  target="_blank"
                  rel="noreferrer"
                >
                  Взять заряд c WB
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="download-app" className="position-relative z-index-1 flex color-black">
        <div className="container max-width-adaptive-lg position-relative z-index-2">
          <div className="grid gap-sm items-start">
            <div
              className="col-5@md position-relative z-index-2 padding-top-xl padding-top-0@md"
              style={{ alignSelf: "center" }}
            >
              <div className="text-component margin-bottom-md">
                {/* <p class="text-sm color-contrast-medium">How it works</p> */}
                <h1 className="color-inherit">
                  {t("home::Ready to be always")} <br />
                  {t("home::in touch?")}
                </h1>
                <p>
                  {t("home::Download the mobile app")} <br />
                  <span className="font-bold">EnerGO</span>{" "}
                  {t("home::from the App Store or Google Play")}
                </p>
              </div>
              <div className="margin-top-sm">
                <div className="app-download-banner__buttons">
                  <a
                    target="blank"
                    href="http://onelink.to/35pdxt"
                    className="download-button download-button--icon js-scroll"
                  >
                    <svg className="icon" width="25" height="30" viewBox="0 0 25 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20.5215 15.7414C20.5358 14.6327 20.8302 13.5457 21.3775 12.5814C21.9248 11.6171 22.7071 10.8069 23.6517 10.2263C23.0516 9.3693 22.26 8.66406 21.3398 8.16655C20.4195 7.66904 19.3959 7.39296 18.3503 7.36025C16.1198 7.12612 13.9574 8.69495 12.8208 8.69495C11.6621 8.69495 9.91212 7.38349 8.02764 7.42226C6.80871 7.46164 5.62077 7.8161 4.57956 8.4511C3.53834 9.0861 2.67937 9.97998 2.08634 11.0456C-0.482559 15.4933 1.43361 22.0298 3.8944 25.625C5.12558 27.3854 6.56449 29.3519 8.44726 29.2821C10.2897 29.2057 10.9778 28.1073 13.2017 28.1073C15.405 28.1073 16.0506 29.2821 17.9716 29.2378C19.9486 29.2057 21.1942 27.4695 22.3822 25.6924C23.2668 24.4381 23.9475 23.0517 24.399 21.5847C23.2505 21.0989 22.2703 20.2858 21.5808 19.2467C20.8912 18.2075 20.5228 16.9885 20.5215 15.7414Z" fill="white" />
                      <path d="M16.893 4.99591C17.971 3.70188 18.502 2.03863 18.3734 0.359375C16.7266 0.532345 15.2054 1.31943 14.1129 2.56381C13.5787 3.17172 13.1696 3.87894 12.9089 4.64505C12.6483 5.41117 12.5411 6.22115 12.5937 7.02868C13.4174 7.03716 14.2323 6.85863 14.977 6.50652C15.7218 6.1544 16.3769 5.6379 16.893 4.99591Z" fill="white" />
                    </svg>
                  </a>
                  <a
                    target="blank"
                    href="https://play.google.com/store/apps/details?id=com.energo.rnapp&hl=ru"
                    className="download-button download-button--icon js-scroll"
                  >
                    <svg className="icon" width="27" height="30" viewBox="0 0 27 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.71873 0.730379C3.97369 0.281888 3.08575 0.241784 2.31134 0.61515L15.2955 13.627L19.5409 9.36184L4.71873 0.730379ZM1.11838 1.81941C0.954572 2.16623 0.866455 2.55202 0.866455 2.94911V26.7507C0.866455 27.1495 0.955136 27.5297 1.12064 27.8691L14.0997 14.8285L1.11838 1.81941ZM15.2973 16.0282L2.33399 29.0531C2.67798 29.2123 3.04401 29.2818 3.40946 29.2818C3.86078 29.2818 4.31096 29.1739 4.71878 28.9288L19.5438 20.2843L15.2973 16.0282ZM25.1861 12.6493C25.181 12.6459 25.1754 12.6425 25.1703 12.6397L21.0548 10.243L16.4925 14.8268L21.0576 19.4015C21.0576 19.4015 25.181 16.9975 25.1861 16.9946C25.9515 16.5298 26.4084 15.7175 26.4084 14.8217C26.4084 13.9258 25.9515 13.1136 25.1861 12.6493Z" fill="white" />
                    </svg>
                  </a>
                  <a
                    target="blank"
                    href="https://www.rustore.ru/catalog/app/com.energo.rnapp"
                    className="download-button download-button--icon js-scroll"
                  >
                    <img className="icon" src="assets/img/Rustore.svg" alt="RuStore" width="34" height="32" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-7@md position-relative z-index-2 margin-bottom-sm flex flex-center">
              <div className="td-cards td-cards--v1">
                <div className="td-cards__inner">
                  <div
                    className="td-cards__card scroll-fx js-scroll-fx"
                    data-scroll-fx-1="rotateX, 60deg, 60deg, 0%, 100%"
                    data-scroll-fx-2="rotateZ, -60deg, -60deg, 0%, 100%"
                    data-scroll-fx-3="translateY, 10%, -55%, 0%, 100%"
                  >
                    <div
                      className="dev-phone dev-phone--top-light"
                      aria-label="Image description"
                    >
                      <div className="dev-phone__body">
                        <div className="dev-phone__media">
                          <div className="dev-phone__notch" />
                          <img
                            src="assets/img/drop your design here-1.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="dev-phone__shadow" />
                    </div>
                  </div>
                  <div
                    className="td-cards__card scroll-fx js-scroll-fx"
                    data-scroll-fx-1="rotateX, 60deg, 60deg, 0%, 100%"
                    data-scroll-fx-2="rotateZ, -60deg, -60deg, 0%, 100%"
                    data-scroll-fx-3="translateY, 20%, -25%, 0%, 100%"
                  >
                    <div
                      className="dev-phone dev-phone--top-light"
                      aria-label="Image description"
                    >
                      <div className="dev-phone__body">
                        <div className="dev-phone__media">
                          <div className="dev-phone__notch" />
                          <img
                            src="assets/img/Map Default energo mobile.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="dev-phone__shadow" />
                    </div>
                  </div>
                  <div
                    className="td-cards__card scroll-fx js-scroll-fx"
                    data-scroll-fx-1="rotateX, 60deg, 60deg, 0%, 100%"
                    data-scroll-fx-2="rotateZ, -60deg, -60deg, 0%, 100%"
                    data-scroll-fx-3="translateY, 30%, 0%, 0%, 100%"
                  >
                    <div
                      className="dev-phone dev-phone--top-light"
                      aria-label="Image description"
                    >
                      <div className="dev-phone__body">
                        <div className="dev-phone__media">
                          <div className="dev-phone__notch" />
                          <img
                            src="assets/img/drop your design here copy.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="dev-phone__shadow" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="position-absolute inset-0 bg-primary z-index-1 origin-top-left scroll-fx js-scroll-fx"
          data-scroll-fx="skewY, -7deg, 0deg, 0%, 50%"
          aria-hidden="true"
        />
      </section>
      {showCookieBanner && (
        <div className="cookie-banner-wrapper">
          <div className="cookie-banner" ref={cookieBannerRef}>
            <div className="cookie-text">
              {t("cookie::We use cookies to improve your user experience. Learn more")}
              {" "}
              <a href="/cookie-policy.pdf" download={t("cookie::Cookie policy.pdf")}>{t("cookie::here")}</a>.
            </div>

            <button onClick={handleAcceptCookies} className="btn-accept">{t("cookie::OK")}</button>
          </div>
        </div>
      )}

      <TelegramFloatButton ref={tgButtonRef} liftOffset={tgButtonLift} />
    </>
  );
}
